export const FooterData = {
  itemList: [
    { label: 'Terms of Use', url: 'https://helyxtech.com/terms-of-service/' },
    { label: 'Privacy Policy', url: 'https://helyxtech.com/privacy-policy/' },
  ],
};
